import { Week39InfoTooltip } from "./Week39InfoTooltip";

export function Week39ExcelNote({ id, workOrderNo, text }: { id: string; workOrderNo: string; text: string }) {
  return <Week39InfoTooltip id={id} label={`${workOrderNo} Excel plan açıklaması`} text={text} symbol="?" />;
}
